<template>
  <div class="modal-header bg-utel-v2-secondary text-primary">
    <h5 class="modal-title">
      <strong>{{ title }}</strong>
    </h5>
    <button 
      type="button" 
      class="btn-close" 
      @click="$emit('close')"
      aria-label="Cerrar"
    >
      ×
    </button>
  </div>
</template>

<script>
export default {
  name: 'ModalHeader',
  
  props: {
    title: { type: String, required: true }
  },

  emits: ['close']
}
</script>

<style scoped>
.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: inherit;
}

.btn-close:hover {
  opacity: 0.7;
}
</style>